export const convertProgramNameString = (string) => {
  // check if string is undefined
  if (string === undefined) {
    return;
  }
  const convertedString = string.split(",")[0];
  return convertedString;
};
